import * as React from "react"
import * as styles from "./style.module.scss"

type Props = {
  copy: {
    main: string,
    sub: string
  },
  mainVisual: string
}

// markup
const DetailMainVisual = (props: Props) => {
  return (
    <div className={styles.detailMainVisual}>
      <div className={styles.contents}>
        <div className={styles.main}>
          {props.copy.main}
        </div>
        <div className={styles.sub}>
          {props.copy.sub}
        </div>
      </div>
      <div className={styles.image}>
        <img src={props.mainVisual} alt="" />
      </div>
    </div>
  )
}

export default DetailMainVisual
